import styled from 'styled-components';
import FONTS from '../../style/fonts';
import COLORS from '../../style/universal.color';

const { mlbGrey2, mlbGrey5 } = COLORS;
const { primaryFont } = FONTS;

// Wrapper for the entire component
export const StyledInningWrapper = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  text-align: center;
`;

// Wrapper for the Basepaths component inside
export const StyledBasepathsWrapper = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Wrapper for the strike and balls count
export const StyledCountWrapper = styled.div<{ dark: boolean }>`
  font-family: ${primaryFont};
  font-size: 12px;
  font-weight: 700;
  color: ${({ dark }) => (dark ? mlbGrey2 : mlbGrey5)};
  height: 11px;
  line-height: 11px;
  margin-top: 8px;
  display: block;
  width: 110%;
  margin-left: -5%;
`;

// Wrapper for the Outs component inside
export const StyledOutsWrapper = styled.div<{ width: number }>`
  margin-top: 8px;
  text-align: center;
  width: ${({ width }) => width}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Wrapper for the InningHalf component inside
export const StyledInningHalf = styled.div<{ dark: boolean }>`
  font-family: ${primaryFont};
  font-size: 12px;
  font-weight: 700;
  color: ${({ dark }) => (dark ? mlbGrey2 : mlbGrey5)};
  height: 11px;
  line-height: 11px;
  margin-bottom: 8px;
  width: 110%;
  margin-left: -5%;
`;

export const StyledOutsText = styled.span`
  text-transform: uppercase;
`;
